import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash-es';

import { handleGetUserProfile } from './actions';
import { IUserState } from './slice.interface';

const initialState: IUserState = {
  data: null,
};

export const userSlice = createSlice({
  name: 'user-profile',
  initialState,
  reducers: {
    removeUserProfile: state => {
      state.data = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(handleGetUserProfile.fulfilled, (state: IUserState, action) => {
      if (!isEqual(state.data, action.payload.data)) {
        state.data = action.payload.data;
      }
    });
  },
});

export const { removeUserProfile } = userSlice.actions;

export default userSlice.reducer;
